import { render } from "./Steps4.vue?vue&type=template&id=30343cc4"
import script from "./Steps4.vue?vue&type=script&lang=js"
export * from "./Steps4.vue?vue&type=script&lang=js"
script.render = render

export default script